import { useState, useEffect } from 'react';

export default function MobileBottomBar() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-50 md:hidden transition-transform duration-300 ${
        visible ? 'translate-y-0' : 'translate-y-full'
      }`}
    >
      <div className="bg-white border-t border-gray-200 shadow-xl px-3 py-2.5 flex items-center gap-2">
        <a
          href="tel:0297386660"
          className="flex-1 flex items-center justify-center gap-2 border border-navy/20 text-navy py-3 rounded-xl font-bold text-sm whitespace-nowrap transition-all duration-200 active:bg-navy/5 cursor-pointer"
        >
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-phone-fill text-base text-navy"></i>
          </span>
          電話で相談
        </a>
        <a
          href="https://lin.ee/Su7CYDD"
          rel="nofollow"
          target="_blank"
          className="flex-1 flex items-center justify-center gap-2 bg-[#00B900] active:bg-[#009900] text-white py-3 rounded-xl font-bold text-sm whitespace-nowrap transition-all duration-200 cursor-pointer"
        >
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-line-fill text-base"></i>
          </span>
          LINE見積もり
        </a>
        <button
          onClick={() => {
            const el = document.querySelector('#contact');
            if (el) el.scrollIntoView({ behavior: 'smooth' });
          }}
          className="flex-1 flex items-center justify-center gap-2 bg-accent active:bg-accent-dark text-white py-3 rounded-xl font-bold text-sm whitespace-nowrap transition-all duration-200 cursor-pointer"
        >
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-mail-send-line text-base"></i>
          </span>
          お問合せ
        </button>
      </div>
      {/* iPhone ホームインジケーター対応の余白 */}
      <div className="bg-white h-safe-area-inset-bottom"></div>
    </div>
  );
}
